import { Module, forwardRef } from '@nestjs/common';
import { MongooseModule } from '@nestjs/mongoose';
import { StatisticsController } from './controllers/statistics.controller';
import { StatisticsService } from './services/statistics.service';
import { CustomerStatisticsService } from './services/customer-statistics.service';
import { CustomerStatistics, CustomerStatisticsSchema } from './schemas/customer-statistics.schema';
import { Order, OrderSchema } from '@/modules/order/schemas/order.schema';
import { Product, ProductSchema } from '@/modules/product/schemas/product.schema';
import { Package, PackageSchema } from '@/modules/package/schemas/package.schema';
import { Expense, ExpenseSchema } from '@/modules/inventory/schemas/expense.schema';
import { Revenue, RevenueSchema } from '@/modules/inventory/schemas/revenue.schema';
import { OrderModule } from '@/modules/order/order.module';

@Module({
  imports: [
    MongooseModule.forFeature([
      { name: CustomerStatistics.name, schema: CustomerStatisticsSchema },
      { name: Order.name, schema: OrderSchema },
      { name: Product.name, schema: ProductSchema },
      { name: Package.name, schema: PackageSchema },
      { name: Expense.name, schema: ExpenseSchema },
      { name: Revenue.name, schema: RevenueSchema },
    ]),
    forwardRef(() => OrderModule),
  ],
  controllers: [StatisticsController],
  providers: [StatisticsService, CustomerStatisticsService],
  exports: [CustomerStatisticsService, StatisticsService],
})
export class StatisticsModule {}

